import { Button } from "@/components/ui/button";
import { useThemeConfig } from "@/components/ui/theme-config-provider";
import ImportListRow from "./ImportListRow";
import { UserProduct } from "@/types";
import { ImportMatchItem } from "./import-list-types";

interface ImportListTableProps {
  rows: ImportMatchItem[];
  products: UserProduct[];
  onChange: (index: number, value: string | null) => void;
  onExecute: () => void;
}

const ImportListTable = ({ rows, products, onChange, onExecute }: ImportListTableProps) => {
  const { theme } = useThemeConfig();
  return (
    <>
      <div role="table" className="space-y-2">
        {rows.map((row, i) => (
          <ImportListRow key={i} row={row} index={i} products={products} onChange={onChange} />
        ))}
      </div>
      <div className="flex justify-end mt-4">
        <Button
          onClick={onExecute}
          className="hover:bg-[var(--btn-bg-hover)]"
          style={{
            backgroundColor: theme.primaryColor,
            color: theme.textPrimaryColor,
            borderRadius: theme.buttonBorderRadius,
            padding: theme.buttonPadding,
            fontWeight: theme.buttonFontWeight,
            transitionDuration: theme.transitionSpeed,
            '--btn-bg-hover': theme.primaryColorDark || theme.primaryColor,
          } as React.CSSProperties}
        >
          Esegui
        </Button>
      </div>
    </>
  );
};

export default ImportListTable;
